import { ACLEntityTypeDto } from './aclEntityType.dto';
import { ACLEntityTypeFieldDto } from './aclEntityTypeField.dto';
import { BaseDto } from './base.dto';
import { MerchantDto } from './merchant.dto';
export class ACLEntityEntryValueOverrideDto extends BaseDto{

    entityTypeId: number;
    fieldId: number;
    entityId: number;
    merchantId: number;
    value: string;
    entityType?: ACLEntityTypeDto;
    field?: ACLEntityTypeFieldDto;
    merchant?: MerchantDto;
}